import { render, staticRenderFns } from "./EditPriceList.vue?vue&type=template&id=dc15be9a&scoped=true"
import script from "./EditPriceList.vue?vue&type=script&lang=js"
export * from "./EditPriceList.vue?vue&type=script&lang=js"
import style0 from "./EditPriceList.vue?vue&type=style&index=0&id=dc15be9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc15be9a",
  null
  
)

export default component.exports